import reducer, { saga as sagas, actions } from './ducks';
import * as translations from './translations';
import widgets from './widgets';

export const name = 'contractItem';
export const realName = 'contractItem';
export { reducer, widgets, sagas, actions, translations };
export * from './routes';
